<template>
  <v-application v-if="access.setting_buttons">
    <v-layout row class="ma-2">
      <v-flex md8>
        <v-crud-card
          name="printer group"
          v-bind:headers="headers"
          v-bind:data="buttons"
          v-bind:save="save"
          v-bind:row="edit"
          v-bind:remove="remove"
          SettingsButton
          v-bind:add_button_name="'add_button'"
          v-bind:saveDisabled="
            !is_valid ||
            (button &&
              typeof button.name == typeof 'invan' &&
              button.name.length > 10)
          "
          Buttons
        >
          <template #top>
            <v-combobox
              v-model="store"
              v-bind:items="stores"
              item-value="_id"
              item-text="name"
              hide-details
              label="Store"
            />
          </template>
          <v-form v-model="is_valid">
            <v-card-text>
              <v-text-field
                v-model="button.name"
                :label="$t('name')"
                ref="name"
                :rules="[fieldRules.required]"
                counter="10"
              />

              <v-autocomplete
                v-model="button.service"
                :items="stores"
                :readonly="button.service != ''"
                item-value="_id"
                item-text="name"
                ref="service"
                :label="$t('store')"
                :rules="[fieldRules.required]"
              />
              <v-autocomplete
                v-model="button.type"
                :items="button_types"
                ref="type"
                :label="$t('type')"
                :rules="[fieldRules.required]"
              />
            </v-card-text>
          </v-form>
        </v-crud-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="button_size_error" persistent width="500">
      <v-card>
        <v-card-text class="pa-5 black--text">
          Maximum number of buttons is 6
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="button_size_error = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
export default {
  name: "Buttons",
  mixins: [Services],
  data: () => ({
    printer_edit_index: -1,
    headers: [
      { text: "Name", value: "name", align: "left" },
      { text: "Type", value: "type", align: "right" },
    ],
    printer: {
      name: null,
    },
    buttons: [],
    button: {
      name: null,
      service: null,
      type: null,
    },
    button_types: [
      {
        text: "Pay in",
        value: "pay_in",
      },
      {
        text: "Pay out",
        value: "pay_out",
      },
      {
        text: "None",
        value: "none",
      },
    ],
    data: [],
    page: 1,
    totalPages: null,
    is_valid: false,
    noAllStores: true,
    noAllEmployes: true,
    button_size_error: false,
  }),
  computed: {
    form() {
      return {
        name: this.button.name,
        service: this.button.service,
        type: this.button.type,
      };
    },
  },
  methods: {
    async remove(items) {
      const indeces = [];
      for (const index in items) {
        indeces.push(items[index]._id);
      }
      await this.$communicator("delete_buttons", {
        params: {
          indexes: indeces,
        },
      });
      this.update();
    },
    edit(item) {
      if (item == null) {
        if (typeof this.buttons == typeof [] && this.buttons.length > 5) {
          this.button_size_error = true;
        }
        this.resetForm();
        this.button = {
          name: null,
          service: this.store ? this.store._id : "",
          type: null,
        };
      } else {
        this.button = this.$copy(item);
      }
    },
    resetForm() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          this.$refs[f].reset();
        }
      });
    },
    async save() {
      if (this.button._id == undefined) {
        await this.$communicator("create_button", {
          params: this.button,
        });
      } else {
        await this.$communicator("update_button", {
          arguments: [this.button._id],
          params: this.button,
        });
      }
      this.button = {
        name: null,
        service: null,
        type: null,
      };
      this.resetForm();
      this.update();
    },
    async update() {
      const buttons = this.$communicator.then(
        this,
        await this.$communicator("get_buttons", {
          params: { service: this.store ? this.store._id : "" },
        })
      );
      if (buttons) {
        this.buttons = buttons;
      }
    },
  },
  watch: {
    stores() {
      if (typeof this.stores == typeof [] && this.stores.length > 0) {
        this.store = this.stores[0];
      }
    },
    store() {
      this.update();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("name"), value: "name", align: "left", available: true },
      { text: this.$t("type"), value: "type", align: "right" , available: true},
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.update();
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
